import React from "react";
import { Search, Map, Code2, ShieldCheck, Rocket } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const STEPS = [
  {
    number: "01",
    icon: Search,
    title: "ENTENDEMOS",
    description: "Conhecemos sua necessidade e seus objetivos.",
  },
  {
    number: "02",
    icon: Map,
    title: "PLANEJAMOS",
    description: "Definimos a melhor solução para o seu negócio.",
  },
  {
    number: "03",
    icon: Code2,
    title: "DESENVOLVEMOS",
    description: "Transformamos o planejamento em uma solução funcional.",
  },
  {
    number: "04",
    icon: ShieldCheck,
    title: "TESTAMOS",
    description: "Ajustamos todos os detalhes antes da entrega.",
  },
  {
    number: "05",
    icon: Rocket,
    title: "ENTREGAMOS",
    description: "Sua solução pronta para gerar resultados.",
  },
];

const Process = () => (
  <section data-testid="process-section" className="relative py-24 lg:py-32">
    <div className="pointer-events-none absolute right-0 top-1/4 h-96 w-96 rounded-full bg-[#00E5FF]/8 blur-[150px]" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        eyebrow="COMO FUNCIONA"
        title={
          <>
            DO PROBLEMA <span className="text-gradient">À SOLUÇÃO.</span>
          </>
        }
        description="Um processo claro e transparente, do primeiro contato até a entrega da sua solução."
      />

      <div className="relative mt-20">
        <div className="absolute left-6 top-0 h-full w-px bg-gradient-to-b from-[#00E5FF]/40 via-[#5B8CFF]/30 to-[#8A2BE2]/40 md:hidden" />
        <div className="absolute left-0 right-0 top-6 hidden h-px bg-gradient-to-r from-[#00E5FF]/40 via-[#5B8CFF]/30 to-[#8A2BE2]/40 md:block" />
        <div className="grid gap-12 md:grid-cols-5 md:gap-6">
          {STEPS.map((step, i) => (
            <Reveal key={step.number} delay={0.1 * i} y={24}>
              <div data-testid={`process-step-${step.number}`} className="group relative flex gap-6 md:flex-col md:gap-0">
                <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#030305] ring-1 ring-white/15 transition-[box-shadow,ring-color] duration-500 group-hover:ring-[#00E5FF]/60 group-hover:shadow-[0_0_28px_rgba(0,229,255,0.35)]">
                  <step.icon className="h-5 w-5 text-[#00E5FF]" />
                </div>
                <div className="md:mt-7">
                  <span className="font-display text-sm font-bold tracking-[0.3em] text-[#7EEEFF]">
                    {step.number}
                  </span>
                  <h3 className="mt-2 font-display text-lg font-bold tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm font-light leading-relaxed text-white/60">
                    {step.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Process;
